import {
  GETAGAINNOTIFICATION,
  GETSAAGAINNOTIFICATION,
  NOTIFICATION_STATUS,
  SAVE_DELETE_NOTIFICATION,

} from "../actionTypes"
import { updateObject } from "./utility";

const initialState = {
  deletedNotification: null,
  notificationCount: null,
  getNotification: false,
  getNotificationAgain: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SAVE_DELETE_NOTIFICATION:
      return updateObject(state, {deletedNotification: action.deletedNotification});

    case NOTIFICATION_STATUS:
      return updateObject(state, { notificationCount: action.count });

    case GETAGAINNOTIFICATION:
      return updateObject(state, { getNotification: action.status });

    case GETSAAGAINNOTIFICATION:
      return updateObject(state, { getNotificationAgain: action.status });

    default:
      return state;
  }
};

export default reducer;
